// extracted by mini-css-extract-plugin
export default {"container":"order-content_container__vp-q+","noOrders":"order-content_noOrders__+wB82","otherOrders":"order-content_otherOrders__+EZQB"};